export default __webpack_public_path__ + "static/media/appicon.dbd31cd6.png";